import './BngTagContainer.css';
import React from 'react';

export default function BngTagContainer({ className = '', children, ...props }) {
  return (
    <div className={`BngTagContainer ${className} flex-center-items`} {...props}>
      {children}
    </div>
  );
}